"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkText = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var LinkText = exports.LinkText = _styledComponents["default"].div.withConfig({
  displayName: "LinkText",
  componentId: "sc-3xixkl-0"
})(["", ";color:", ";border-color:", ";transition:color ", " ", ";overflow-wrap:break-word;&::after{", " content:'';position:relative;border-color:inherit;}"], (0, _index.rootStyle)(), (0, _index.cssColorValue)(_index.semanticColors.textBase), (0, _index.cssColorValue)(_index.semanticColors.essentialBase), _index.focusTransitionFade, _index.focusTransitionType, (0, _index.focusBottomBorderStyle)(0));